import { PortalRequestsPermission } from '@idc-forms/permissions'
import { Can } from '@/shared/components/can'
import { ActiveFlowPanel } from '../active-flow-panel'
import { PreviousFlowsPanel } from '../previous-flows-panel'
import { ClientCreateFlowForm } from './client-create-flow-form'

type ClientFlowsTabProps = {
  clientId: string
  clientType: 'individual' | 'juridical'
  clientName: string
  clientEmail: string | null
  hasActiveFlow: boolean
}

/**
 * "Flujos" tab. El `ActiveFlowPanel` es el dueño de la decisión: él consulta TODOS los
 * flujos del cliente (incluido un enlace EXPIRADO, que la lista marca como "sin flujo
 * activo" por ser terminal) y decide entre gestionarlo (estado, recordatorios, renovar)
 * o caer al formulario de creación cuando no hay NINGÚN flujo. Por eso el form de crear
 * se pasa como fallback en lugar de gatearlo con `hasActiveFlow` (que ignora los
 * expirados y dejaba la renovación inalcanzable).
 */
export function ClientFlowsTab({
  clientId,
  clientType,
  clientName,
  clientEmail
}: ClientFlowsTabProps) {
  return (
    <div className="flex flex-col gap-6">
      <ActiveFlowPanel
        clientId={clientId}
        clientType={clientType}
        renderEmpty={() => (
          <Can
            permission={PortalRequestsPermission.CreatePortalRequest}
            fallback={
              <p className="text-xs text-muted-foreground">
                El cliente no tiene flujos y no tienes permiso para crear uno.
              </p>
            }
          >
            <section className="flex flex-col gap-3">
              <span className="text-xs font-medium uppercase text-muted-foreground">
                Nuevo flujo
              </span>
              <ClientCreateFlowForm
                clientId={clientId}
                clientType={clientType}
                clientName={clientName}
                clientEmail={clientEmail}
              />
            </section>
          </Can>
        )}
      />
      <PreviousFlowsPanel clientId={clientId} clientName={clientName} />
    </div>
  )
}
